/**
 * Reusable "Thank you for your support" note.
 * Text and position are admin-customizable (via customize.thank_you_* + section_order).
 */
export function ThankYouSection({ siteSettings, isVisible }) {
  if (!isVisible('thank_you')) return null;
  const c = siteSettings?.customize || {};
  const title = c.thank_you_title || 'Thank You For Your Support';
  const body = c.thank_you_body || 'Every purchase directly supports an independent artist creating from a wheelchair. No label. No team. Just passion, persistence, and a second life worth living. I.O.M.S.L';
  return (
    <section className="py-12 px-4" data-testid="thank-you-section">
      <div className="max-w-3xl mx-auto text-center">
        <div className="border-t border-[#262626] pt-8">
          <p className="text-[var(--accent,#DAA520)] font-cabinet text-2xl sm:text-3xl font-bold uppercase tracking-tight mb-3 whitespace-pre-line">
            {title}
          </p>
          <p className="text-[#A3A3A3] text-sm sm:text-base leading-relaxed whitespace-pre-line">
            {body}
          </p>
        </div>
      </div>
    </section>
  );
}
